<template>
  <div v-if="isOpen" class="profile-side-panel-overlay" @click="close">
    <div class="profile-side-panel" @click.stop>
      <div class="profile-side-panel__header">
        <button class="profile-side-panel__close" @click="close">&times;</button>
      </div>
      <div class="profile-side-panel__body">
        <div v-if="loading" class="profile-side-panel__loading">
          <div class="loading-spinner"></div>
        </div>
        <div v-else v-html="profileHtml"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileSidePanel',
  data() {
    return {
      isOpen: false,
      loading: false,
      profileHtml: ''
    }
  },
  methods: {
    open(url) {
      this.isOpen = true
      this.loading = true
      this.profileHtml = ''

      fetch(url)
        .then(response => response.text())
        .then(html => {
          this.profileHtml = html
          this.loading = false
        })
        .catch(err => {
          console.error('Error loading profile:', err)
          this.loading = false
        })
    },
    close() {
      this.isOpen = false
      this.profileHtml = ''
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.close()
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>
